import React from 'react';
import PropTypes from 'prop-types';
import { iconGray } from '../../theme';

const Globe = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 29.75 34">
    <path
      d="M27.625-29.75H4.25A4.25,4.25,0,0,0,0-25.5V0A4.25,4.25,0,0,0,4.25,4.25H27.625A2.125,2.125,0,0,0,29.75,2.125v-29.75A2.125,2.125,0,0,0,27.625-29.75Zm0,31.875H4.25A2.128,2.128,0,0,1,2.125,0V-25.5A2.128,2.128,0,0,1,4.25-27.625H27.625ZM7.437-2.125H22.312a1.066,1.066,0,0,0,1.062-1.062A1.066,1.066,0,0,0,22.312-4.25H7.437A1.066,1.066,0,0,0,6.375-3.187,1.066,1.066,0,0,0,7.437-2.125ZM14.875-8.5a8.5,8.5,0,0,0,8.5-8.5,8.5,8.5,0,0,0-8.5-8.5,8.5,8.5,0,0,0-8.5,8.5A8.5,8.5,0,0,0,14.875-8.5Zm6.267-9.562h-2.6a14.985,14.985,0,0,0-.944-4.676A6.365,6.365,0,0,1,21.142-18.062Zm-2.6,2.125h2.6A6.366,6.366,0,0,1,17.6-11.262,14.967,14.967,0,0,0,18.547-15.937Zm-3.672-7.351c.511.495,1.379,2.286,1.556,5.226H13.318C13.5-21,14.364-22.793,14.875-23.288Zm1.556,7.351c-.177,2.939-1.045,4.731-1.556,5.226-.511-.495-1.379-2.286-1.556-5.226Zm-4.284-6.8a14.967,14.967,0,0,0-.944,4.676h-2.6A6.365,6.365,0,0,1,12.147-22.738Zm-.944,6.8a14.985,14.985,0,0,0,.944,4.676,6.365,6.365,0,0,1-3.539-4.676Z"
      transform="translate(0 29.75)"
      fill={color}
    />
  </svg>
);

Globe.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Globe.defaultProps = {
  width: 29.75,
  height: 34,
  color: iconGray,
};

export default Globe;
